import styled from "styled-components";
export const SupplierUnconfirmedOrdersStyle = styled.div``;
